import { TableContainer } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AvatarGroup from "@material-ui/lab/AvatarGroup";
import Pagination from "@material-ui/lab/Pagination";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import Tooltip from "@mui/material/Tooltip";
import Action from "components/ActionPopOver";
import CopyButton from "components/CopyButton/CopyButton";
import Loader from "components/loader/Loader";
import { MemberCardFamilyMembers } from "components/MemberCard/Theme";
import React from 'react';
import { formatPhoneNumber } from 'react-phone-number-input';
import { useHistory } from "react-router";
import { mailTo, phoneTo } from "utils/contactTo";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    paddingLeft: "20px !important",
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "12px",
    color: "#4F4F4F",
  },
}))(TableCell);


const AccountListViewTable = ({
  list,
  loading,
  perPage,
  page,
  totalCount,
  setPage,
  onMergeClick,
  setTypeUser,
  setSelectedAccount,
  setOpenAlert,
}) => {
  const history = useHistory();

  const columns = [
    {
      id: "account_name",
      label: "Account Name",
    },
    {
      id: "adult_1",
      label: "Adult 1",
    },
    {
      id: "adult_2",
      label: "Adult 2",
    },
    {
      id: "email_1",
      label: "Email 1",
    },
    {
      id: "email_2",
      label: "Email 2",
    },
    {
      id: "mobile_1",
      label: "Mobile 1",
    },
    {
      id: "mobile_2",
      label: "Mobile 2",
    },
    {
      id: "home_1",
      label: "Home 1",
    },
    {
      id: "home_2",
      label: "Home 2",
    },


    {
      id: "family_members",
      label: "Family Members",
    },
    {
      id: "account_type",
      label: "Account Type",
    },
    {
      id: "billing_type",
      label: "Billing Type",
    },
    {
      id: "action",
      label: "Action",
      className: "sticky-header-column",
    },
  ];

  return (
    <div
      className="current-class-table-container"
      style={{
        padding: "17px"
      }}>
      <div>
        <TableContainer className="scroll-table">
          <Table
            class="main-tables"
            aria-label="collapsible table"
            style={{ width: "100%" }}
          >
            <TableHead className="charges-table sticky-table-header">
              <TableRow>
                {columns?.map((column) => (
                  <TableCellHead
                    key={column.id}
                    align="left" className={`class__header__cell year__head ${column.className}`}
                  >
                    {column?.id !== "action" && (
                      <div className="d-flex h-100 justify-content-start align-items-center" style={{ gap: "10px" }}>
                        {column?.label?.toUpperCase()}
                      </div>
                    )}
                  </TableCellHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              className="tran-table-body"
              style={{
                backgroundColor: "white",
              }}
            >
              {loading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <div
                      className="user__loader"
                      style={{ height: "320px" }}
                    >
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : list?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <h6 style={{ height: "320px", marginTop: "100px" }}>
                      No Data Found
                    </h6>
                  </TableCell>
                </TableRow>
              ) : (
                list?.map((row, i) => (
                  <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                    <TableCellBody align="left">
                      <div className="user-cotainer-home col m-0 p-0 h-100">
                        <div className="name-container flex-row-reverse w-100 text-left mr-5 p-0">
                          <Tooltip
                            title={`${row?.["Account name"]}`}
                            placement="top"
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                              <p
                                className="id-container w-100 table-field-hover-data"
                                style={{ wordBreak: "break-word", whiteSpace: "nowrap", margin: 0 }}
                                onClick={() => {
                                  history.push(`/member-details/${row?.accountId}`);
                                }}
                              >
                                {row?.["Account name"]}
                              </p>
                              {row?.accountId && (
                                <a
                                  href={`/member-details/${row?.accountId}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  onClick={(e) => e.stopPropagation()}
                                  style={{ display: "flex", alignItems: "center", color: "#2555EF", flexShrink: 0 }}
                                >
                                  <OpenInNewOutlinedIcon style={{ fontSize: 10, width: 18, height: 18 }} />
                                </a>
                              )}
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Adult 1"]?.trim() ? row?.["Adult 1"] : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Adult 2"]?.trim() ? row?.["Adult 2"] : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Email 1"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={mailTo({ email: row?.["Email 1"], content: "" })}>
                              {row?.["Email 1"]}
                            </a>
                            <CopyButton value={row?.["Email 1"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Email 2"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={mailTo({ email: row?.["Email 2"], content: "" })}>
                              {row?.["Email 2"]}
                            </a>
                            <CopyButton value={row?.["Email 2"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Mobile 1"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={phoneTo({ phone: row?.["Mobile 1"] })}>
                              {formatPhoneNumber(row?.["Mobile 1"])}
                            </a>
                            <CopyButton value={row?.["Mobile 1"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Mobile 2"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={phoneTo({ phone: row?.["Mobile 2"] })}>
                              {formatPhoneNumber(row?.["Mobile 2"])}
                            </a>
                            <CopyButton value={row?.["Mobile 2"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>

                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Mobile 1"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={phoneTo({ phone: row?.["Home 1"] })}>
                              {formatPhoneNumber(row?.["Home 1"])}
                            </a>
                            <CopyButton value={row?.["Home 1"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Mobile 2"]?.trim() ? (
                          <div className="d-flex align-items-center position-relative" style={{
                            gap: "10px",
                          }}>
                            <a href={phoneTo({ phone: row?.["Home 2"] })}>
                              {formatPhoneNumber(row?.["Home 2"])}
                            </a>
                            <CopyButton value={row?.["Home 2"]}
                              styles={{
                                position: "relative",
                                right: "unset",
                                top: "unset",
                                transform: "translate(0, 0)",
                              }}
                              copyTextStyle={{
                                top: "70%",
                              }}
                            />
                          </div>
                        ) : " - "}
                      </div>
                    </TableCellBody>


                    <TableCellBody align="left">
                      <MemberCardFamilyMembers className="avatar-container"
                      >
                        <AvatarGroup max={4}
                          sx={
                            {
                              "& .MuiAvatar-colorDefault": {
                                width: "30px",
                                height: "30px",
                                fontSize: "12px",
                                fontWeight: "bold",
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                              },
                            }
                          }
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            history.push(`/member-details/${row?.accountId}?tab=Family`);
                          }}
                        >
                          {row?.family_members?.length &&
                            row?.family_members.map((family_member, index) => {
                              return (
                                <Tooltip
                                  title={`${family_member?.first_name} ${family_member?.last_name}`}
                                >
                                  <Avatar
                                    key={index}
                                    alt={family_member?.first_name}
                                    src={family_member?.profile_img}
                                    onClick={family_member?._id ? (e) => {
                                      e.stopPropagation();
                                      history.push(`/member-details/${row?.accountId}?q=${family_member?._id}&tab=Family`);
                                    } : null}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {(
                                      family_member.first_name?.[0] + family_member.last_name?.[0]
                                    )?.toString()?.toUpperCase()}
                                  </Avatar>
                                </Tooltip>
                              );
                            })}
                          {!row?.family_members?.length ? <div className=""></div> : ""}
                        </AvatarGroup>
                      </MemberCardFamilyMembers>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Account type"]?.trim() ? row?.["Account type"] : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left">
                      <div className="row-data">
                        {row?.["Billing type"]?.trim() ? row?.["Billing type"] : " - "}
                      </div>
                    </TableCellBody>
                    <TableCellBody align="left" className="sticky-body-column">
                      <div className="row-data justify-content-center" style={{ cursor: "pointer" }}>
                        <Action
                          onEditClick={() => {
                            setTypeUser(false);
                            history.push(`/member-details/${row?.accountId}`);
                          }}
                          onDeleteClick={() => {
                            setSelectedAccount(row);
                            setOpenAlert(true);
                          }}
                          onMergeClick={() => onMergeClick(row)}
                          style={{
                            width: "16px",
                            height: "16px",
                          }}
                          checkActive={true}
                        />
                      </div>
                    </TableCellBody>
                  </TableRow>
                )
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        className={`w-100 pagination-custom mt-2 mb-4 py-4`}
      >
        <Pagination
          count={Math.ceil(totalCount / 30)}
          color="primary"
          page={page}
          variant="outlined"
          onChange={(event, value) => {
            setPage(value);
          }}
        />
      </div>
    </div>

  )
}

export default AccountListViewTable
